itsoftApp.createModule("burgerMenu", function() {
    var menuBtn = document.querySelector(".page-header__menu-burger");

    menuBtn.addEventListener("click", function() {
        $(this).toggleClass("is-active");
        $(".page-header__main-menu").toggleClass("is-active");
        $(".page-header").toggleClass("is-active");
        $(".svg-icon").toggleClass("is-active");
        $("body").toggleClass("is-active");
        if ($(this).hasClass("is-active")) {
            $(".page-header__submenu").removeClass("is-active");
            $(".page-header__menu-link--multiple").removeClass("is-active");
        }
    });

    $(".page-header__menu-link--multiple").on("click", function() {
        if ($(window).width() <= 960) {
            $(this).toggleClass("is-active");
            $(this).closest(".page-header__menu-item").find(".page-header__submenu").toggleClass("is-active");
            return false;
        }
    });

    // Footer menu on mobile
    $(".page-footer__menu-link--multiple").on("click", function() {
        if ($(window).width() <= 960) {
            $(this).toggleClass("is-active");
            $(this).closest(".page-footer__menu-item").find(".page-footer__submenu").toggleClass("is-active");
            return false;
        }
    });

    // Resize and initial
    // header
    $(window).resize(function() {
        if ($(window).width() > 960) {
            $(".page-header__menu-burger").removeClass("is-active");
            $(".page-header__main-menu").removeClass("is-active");
            $(".page-header").removeClass("is-active");
            $(".svg-icon").removeClass("is-active");
            $(".svg-icon.svg-icon--main").addClass("is-active");
            $("body").removeClass("is-active");
            $(".page-header__submenu").removeClass("is-active");
            $(".page-header__menu-link--multiple").removeClass("is-active");
            $(".page-footer__menu-link--multiple").removeClass("is-active");
        }
    });
    // footer
    $(window).resize(function() {
        if ($(window).width() > 420) {
            $(".page-footer__submenu").attr("style", "");
        }
    });

});